import * as React from 'react';
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Link, Navigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { app } from '../config/app.js';

import Typography from '@mui/material/Typography';
export function listItems(funcLogout,ruoloCfg) {
 // console.log(ruoloCfg);
  const menuItems = [
    { key: 'dashboard', to: '/dashboard/', icon: <DashboardIcon />, text: 'Dashboard' },
    { key: 'guide', to: '/guide/', icon: <TimeToLeaveIcon />, text: 'Guide' },
    { key: 'candidati', to: '/candidati/', icon: <SupportAgentIcon />, text: 'Candidati' },
    { key: 'utenti', to: '/utenti/', icon: <SupportAgentIcon />, text: 'Utenti' },
   // { key: 'archivioGuide', to: '/archivioGuide/', icon: <FindInPageIcon />, text: 'Archivio Guide' },
    { key: 'logout', onClick: funcLogout, icon: <LogoutIcon />, text: 'Logout' }
  ];
  
  ruoloCfg.menuToHide.forEach((item) => {
    menuItems.forEach((menuItem, index) => {
      if (menuItem.key === item) {
        menuItems.splice(index, 1);
      }
    });
  });

  return (
    <React.Fragment>
      {menuItems.map(item => (
        <ListItemButton
          key={item.key}
          component={item.to ? Link : 'button'}
          to={item.to}
          onClick={item.onClick}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      ))}
      <Typography sx={{ mt: 5, textAlign: 'center', fontStyle: 'italic', fontSize: '0.8rem' }} >
      {app.name} v. {app.version}
      </Typography>
    </React.Fragment>
  );
}